import { render, staticRenderFns } from "./shop-cart.vue?vue&type=template&id=15346a66&"
import script from "./shop-cart.vue?vue&type=script&lang=js&"
export * from "./shop-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports